import React, { useEffect } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import OurStory from "../components/about/OurStory";
import OurBeliefs from "../components/about/OurBeliefs";
import UniqueFeatures from "../components/about/UniqueFeatures";
import SocialImpact from "../components/about/SocialImpact";
import Roadmap from "../components/about/Roadmap";
import BusinessSolutions from "../components/about/BusinessSolutions";
import ContactUs from "../components/about/ContactUs";
import HeroSection from "@/components/about/AboutHeroSection";
import { Helmet } from "react-helmet-async";

const AboutPage: React.FC = () => {
  // --- Structured Data: AboutPage + Publisher (Organization) ---
  const structuredData = {
      "@context": "https://schema.org",
      "@type": "AboutPage",
      name: "درباره دلبند",
      url: "https://delband.com/about",
      description: "دلبند یک پلتفرم سلامت دیجیتال نسل سوم (Med-3.0) است که با هدف مراقبت پیشگیرانه، پایش مداوم و افزایش ایمنی خانواده‌ها و نیروی انسانی سازمان‌ها توسعه یافته است.",
      publisher: {
          "@type": "Organization",
          name: "Delband",
          url: "https://delband.com",
          logo: "https://delband.com/assets/logo.png",
          sameAs: ["https://www.linkedin.com/company/delband", "https://instagram.com/delbandhealth", "https://x.com/delbandhealth"],
      },
      mainEntity: {
          "@type": "Organization",
          name: "Delband",
          foundingDate: "2023-01-01", // به‌روزرسانی شود
          contactPoint: {
              "@type": "ContactPoint",
              telephone: "+98-21-9100XXXX",
              contactType: "Customer Support",
              areaServed: "IR",
          },
      },
  };

  return (
    <>
      <Helmet>
        <title>دلبند | درباره ما — ماموریت، چشم‌انداز و ارزش‌ها</title>
        <meta name="description" content="دلبند؛ اکوسیستم سلامت هوشمند (Med-3.0) با ماموریت پیشگیری و مراقبت مستمر — ترکیب پوشیدنی‌های ایمن، تحلیل هوشمند و راهکارهای سازمانی برای ارتقای سلامت خانواده‌ها و کارکنان." />
        <meta name="keywords" content="درباره دلبند, دلبند, Delband, ماموریت, چشم‌انداز, Med-3.0, سلامت دیجیتال, پوشیدنی سلامت, ردیاب کودک, سلامت سازمانی, ایران" />
        <link rel="canonical" href="https://delband.com/about" />
        <meta property="og:title" content="دلبند — درباره ما" />
        <meta property="og:description" content="آشنایی با ماموریت، چشم‌انداز و ارزش‌های دلبند در ساخت اکوسیستم سلامت پیش‌بینی‌محور و ایمن برای خانواده‌ها و سازمان‌ها." />
        <meta property="og:image" content="https://delband.com/assets/about-og.jpg" />
        <meta property="og:url" content="https://delband.com/about" />
        <meta property="og:type" content="article" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="دلبند — درباره ما" />
        <meta name="twitter:description" content="درباره دلبند: چگونه پوشیدنی‌های هوشمند و AI ما مراقبتِ پیشگیرانه را برای خانواده‌ها و سازمان‌ها ممکن می‌سازند." />
        <meta name="twitter:image" content="https://delband.com/assets/about-og.jpg" />
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      </Helmet>
      <div className="bg-[#F8F9FC]">
        <Header />

        <main className="container mx-auto px-2 pb-8 pt-24 sm:pt-24 md:pt-21 max-w-7xl">
          <HeroSection />
          <OurStory />
          <OurBeliefs />
          <UniqueFeatures />
          <Roadmap />
          <SocialImpact />
          <BusinessSolutions />
          <ContactUs id="contact-section"/>
        </main>

        <Footer />
      </div>
    </>
  );
};

export default AboutPage;
